import { render, staticRenderFns } from "./CodeTypeDialog.vue?vue&type=template&id=30133a12&scoped=true&"
import script from "./CodeTypeDialog.vue?vue&type=script&lang=js&"
export * from "./CodeTypeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30133a12",
  null
  
)

export default component.exports